<!-- eslint-disable sonarjs/no-duplicate-string -->
<template>
  <Sect id="SectionProjects">
    <h2>Saulės parkai</h2>
    <div v-if="projects" class="mainContainer">
      <CardProject
        v-for="(project, index) in projectsToDisplay"
        :key="index"
        :doShowStartDateStatus="true"
        :project="project" />
    </div>
    <div v-if="showViewMore" class="viewMore">
      <Route class="Btn arrow" to="SolarPlants">
        VISI SAULĖS PARKAI
      </Route>
    </div>
  </Sect>
</template>

<script>
import CardProject from './CardProject'
// import HorizontalScroll from './HorizontalScroll'
// import ProjectMocker from 'mixins/ProjectMocker'
import ProjectBundler from 'mixins/ProjectBundler'

export default {
  mixins: [ProjectBundler],
  components: { CardProject },
  props: {
    displayCount: Number,
    showViewMore: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    projectsCount() {
      return this.projects.length
    },
    projectsToDisplay() {
      if (!this.displayCount) return this.projects

      return this.projects.slice(0, this.displayCount)
    },
  },
}
</script>

<style lang="scss">
#SectionProjects {
  background: $white-ter;
  margin: 0 2rem;
  // display: flex;
  position: relative;

  h2 {
    @include dotAbove(1.5rem);
    padding-bottom: 2rem;
  }

  .mainContainer {
    display: grid;
    gap: 2rem;
    grid-template-columns: 1fr;
    position: relative;
    @include md {
      grid-template-columns: repeat(2, 1fr);
    }
    @include xl {
      grid-template-columns: repeat(3, 1fr);
    }
  }

  // .CardProject {
  //   flex: 0 1 85%;
  //   @include md {
  //     flex: 0 1 45%;
  //   }
  //   @include xl {
  //     flex: 0 1 30%;
  //   }
  // }

  .viewMore {
    display: flex;
    justify-content: center;
    margin: 4rem 0;

    > a {
      width: 18rem;
    }
  }
}
</style>
